import '@calcom/atoms/globals.min.css';
import * as React from 'react';
import { EncryptedText } from '@epihub/web/src/tailwind/components/EncryptedText';
import { useSfyr } from '../../_ctx/sfyr';

export const CalendarHeader = () => {
  const sfyr = useSfyr();
  return (
    <h1 className='text-3xl font-bold'>
      <EncryptedText
        text={sfyr('ui.{lang}.calendar.title', {
          defaults: {
            'ui.{lang=en}.calendar.title': 'BOOK MY CALENDAR',
            'ui.{lang=it}.calendar.title': 'PRENOTA UN APPUNTAMENTO',
          },
        })}
        encryptedClassName='text-neutral-500'
        revealedClassName='dark:text-white text-black'
        revealDelayMs={50}
      />
    </h1>
  );
};
